import {CreateFields, CustomForm} from '../services';
import resolver, {ResolverSettings} from './utils/resolver';

class CustomFormApi {
  readonly ENDPOINTS = {
    customForm: (params = '') => `guest-custom-form/form/?${params}`,
    customFormById: (id: string, params = '') =>
      `guest-custom-form/form/${id}/?${params}`,
    createFields: (params = '') => `guest-custom-form/custom-values/?${params}`,
  };

  getCustomForm(params: string, resolverSettings?: ResolverSettings) {
    return resolver(this.ENDPOINTS.customForm(params), null, resolverSettings);
  }

  getCustomFormById(id: string, params: string, resolverSettings?: ResolverSettings) {
    return resolver(this.ENDPOINTS.customFormById(id, params), null, resolverSettings);
  }

  createFields(payload: CreateFields, params = '', resolverSettings?: ResolverSettings) {
    return resolver<CustomForm>(
      this.ENDPOINTS.createFields(params),
      {
        method: 'POST',
        body: JSON.stringify(payload),
      },
      resolverSettings,
    );
  }
}

export {CustomFormApi};
